import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';

// action creators
import { appointmentCancel, appointmentConfirm } from '../../../actions/appointmentActions';
import { tooltipHide } from '../../../actions/tooltipActions';

// components
import { Button } from '../../shared/_form';
import Modal from '../../shared/_Modal';

class AlreadyPostedModal extends React.Component {
  static propTypes = {
    hideTooltip:        PropTypes.func.isRequired,
    id:                 PropTypes.string
  }

  componentWillUnmount() {
    this._handleHideModal();
  }

  render() {
    const { id } = this.props;

    return (
      <Modal id={ id }>
        <div className='modal__header'>
          This appointment is already offered.
        </div>

        <div>
          You can see all Your posted offers in the Trade Post market.
        </div>

        <div className='modal__actions'>
          <Button className='form__button form__button--purple' onClick={ this._handleHideModal } type='button'>Back</Button>
        </div>
      </Modal>
    );
  }

  // private

  _handleHideModal          = this._handleHideModal.bind(this);

  _handleHideModal() {
    const { hideTooltip, id } = this.props;

    hideTooltip(id);
  }
}

const mapDispatchToProps = (dispatch) => ({
  hideTooltip: (id) => dispatch(tooltipHide({ id: id }))
});

export default connect(null, mapDispatchToProps)(AlreadyPostedModal);



// WEBPACK FOOTER //
// ./app/components/reps/appointments/_AlreadyPostedModal.jsx